<template>
  <main class="l-main p-organization">
    <TitleMain icon="projects" isFaqHide>
      <span class="title">{{ email }}のお客様一覧</span>
    </TitleMain>
    <div class="l-container">
      <ListOrganization :items="organizations" />
    </div>
  </main>
</template>

<script>
import ListOrganization from '@/components/organization/ListOrganization';
import TitleMain from '@/components/TitleMain';

export default {
  components: {
    ListOrganization,
    TitleMain
  },
  computed: {
    organizations() {
      return this.$store.state.user.me.organizations;
    },
    email() {
      return this.$store.state.user.status.email;
    }
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      // 組織のデータをリセットする
      this.$store.dispatch('organizations/reset');
      // サイト一覧のデータをリセットする
      this.$store.dispatch('user/resetData');
    }
  }
};
</script>
